import React from 'react'
import Fotter from './Fotter'

const Blog = () => {
  return (
    <div>
      <Fotter/>
    </div>
  )
}

export default Blog